/**
 * Introduction documentation page — what is m8tes, core concepts, how it works.
 */

import { createFileRoute } from "@tanstack/react-router";
import { DocsPage } from "@/components/docs/docs-page";
import { introductionContent } from "@/constants/docs/introduction";

export const Route = createFileRoute("/docs/introduction")({
	component: IntroductionPage,
});

function IntroductionPage() {
	return <DocsPage title="Introduction" content={introductionContent} />;
}
